import {
   createOrgGuard,
   orgGuard,
   subscriptionProjectGuard,
} from "../guards/composable"
import OnboardingHome from "../../views/onboarding/OnboardingHome.vue"
import SelectSubscription from "../../views/onboarding/SelectSubscription.vue"
import { CreateOrg } from "@views/onboarding"

export default [
   {
      path: "/onboarding/create-org",
      name: "OnboardingCreateOrg",
      component: CreateOrg,
      meta: {
         layout: "AppLayoutDefault", // should be OnboardingLayout so that users can log out, but there's a spacing issue
      },
      beforeEnter: createOrgGuard,
   },
   {
      path: "/onboarding/select-subscription",
      name: "SelectSubscription",
      component: SelectSubscription,
      meta: {
         layout: "OrgsLayout",
      },
      beforeEnter: orgGuard,
   },
   {
      name: "OnboardingHome",
      path: "/orgs/:orgSlug/projects/:projectId/onboarding",
      component: OnboardingHome,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
]
